module.exports = __webpack_public_path__ + "mainCover.ceb6b037.png";